// shopify-theme/assets/db-exp-track.js
// Coda di eventi dell'A/B test verso ecom-ateam.
//
// Regole non negoziabili: non blocca mai la UI, non lancia mai eccezioni, e se
// l'endpoint è irraggiungibile lo store funziona identico.
//
// Il flush su `visibilitychange` usa sendBeacon e non fetch: al momento in cui la
// pagina si scarica fetch viene ucciso, e proprio gli eventi che contano di più
// (checkout_click, offer_dwell) capitano in quell'istante.

// L'app ecom-ateam, dove gira davvero. Verificato raggiungibile con certificato
// valido; `/api/exp/collect` risponde 401 finché il server ha `main` (la rotta
// vive sul branch), e diventa pubblica appena il branch è deployato.
//
// Storia di due hostname sbagliati, entrambi corretti lo stesso giorno:
//  - `exp.dermabella.it`: il dominio di secondo livello NON ESISTE — il registro
//    .it risponde `Status: AVAILABLE`, cioè non registrato da nessuno. La
//    risoluzione DNS falliva prima ancora del preflight CORS: raccolta a zero,
//    senza un solo errore visibile in pagina.
//  - `exp.dermabellabeauty.com`: sottodominio plausibile del dominio reale dello
//    store, ma nessun record DNS lo ha mai puntato da nessuna parte, e avrebbe
//    richiesto di crearne uno per un servizio che era GIÀ online altrove.
//
// L'hostname contiene l'IP del server (`sslip.io` risolve qualunque IP incorporato
// nel nome, senza bisogno di configurare un DNS). Comodo ora, fragile dopo: se il
// VPS cambia IP, questo indirizzo smette di risolvere. Il giorno che ci sarà un
// dominio proprio, è una riga qui e una voce nella whitelist di route.ts.
//
// Resta cross-origin rispetto allo storefront: whitelist e preflight lato app
// servono comunque.
const ENDPOINT = 'https://ecom-ateam.46.224.86.9.sslip.io/api/exp/collect';
const MAX_BATCH = 50;
const IDLE_MS = 3000;
// Tetto d'attesa per il riallineamento carrello (evento 'db-exp:rebound' di
// db-exp-assign.liquid) prima di mandare comunque session_start. Il fetch che
// lo determina (/cart.js) e' same-origin e in pratica risolve in una frazione
// di questo tempo; il tetto esiste solo per il caso in cui non risolva mai.
const REBOUND_WAIT_MS = 1200;

const exp = window.DbExp;
const active = Boolean(exp && exp.status === 'running');

let queue = [];
// La sessione tecnica appartiene a UN test (vedi la sentinella
// `db_session_test` in db-exp-assign.liquid): quando ne parte uno nuovo, sid
// e sequenza si rinnovano INSIEME. Ereditare la sequenza con un sid nuovo
// falserebbe il conteggio degli eventi persi, che si calcola confrontando il
// massimo `seq` ricevuto col numero di righe.
// Dal 19/08/2026 la sessione appartiene anche a UN braccio (`db_session_arm`,
// vedi sidPerTest in db-exp-assign.liquid): con l'offerta legata alla pagina
// lo stesso visitatore cambia braccio cambiando URL, e il sid si rinnova.
// La sequenza deve rinnovarsi INSIEME, con lo stesso criterio: ereditarla
// con un sid nuovo falserebbe il conteggio degli eventi persi.
let sessioneDiQuestoTest = false;
try {
  sessioneDiQuestoTest =
    Boolean(exp) &&
    sessionStorage.getItem('db_session_test') === exp.testId &&
    sessionStorage.getItem('db_session_arm') === exp.arm;
} catch (e) { sessioneDiQuestoTest = false; }
let seq = 0;
try {
  seq = sessioneDiQuestoTest ? Number(sessionStorage.getItem('db_seq')) || 0 : 0;
} catch (e) { seq = 0; }
let idleTimer = null;
let contextSent = false;

// DIFETTO NOTO, non corretto di proposito — collisione (sid, seq) fra schede
// clonate. `db_sid` e `db_seq` vivono in sessionStorage, che PERSISTE nella
// navigazione della stessa scheda ma viene CLONATA (non condivisa dal vivo)
// quando quella pagina apre un link in una scheda nuova (target="_blank",
// window.open) verso lo stesso dominio. Le due schede ripartono dallo stesso
// sid e dallo stesso contatore seq persistiti al momento del clone, poi
// incrementano `seq` ciascuna nella propria memoria in modo indipendente:
// prima o poi le due producono lo stesso (sid, seq) per un evento diverso.
// Misurato su DB reale (scratch, non produzione): il server scarta la
// seconda riga in silenzio (`ON CONFLICT (sid, seq) DO NOTHING` in
// repository.ts) — e' PERDITA di un evento, non un doppio conteggio ne' una
// corruzione di dati.
//
// Due correzioni valutate e SCARTATE, non per pigrizia:
//
// 1. Sid nuovo per scheda (invece di riusare quello clonato). Eliminerebbe la
//    collisione alla radice, ma gonfierebbe il denominatore delle sessioni:
//    una visita che apre un link in una scheda nuova diventerebbe DUE sessioni
//    in experiment_sessions. E' l'input della metrica primaria di decisione —
//    falserebbe conversion rate, ATC rate, e l'SRM che dovrebbe accorgersi
//    proprio di problemi come questo diventerebbe esso stesso un problema.
//    Inaccettabile: peggiore del difetto che risolverebbe.
//
// 2. Seq non collidente per scheda (es. uno stride/offset casuale assegnato
//    per scheda, mai persistito, cosi' il clone non lo trascina). Scartata
//    per lo stesso motivo per cui non abbiamo spedito un parametro statistico
//    non validato altrove in questo esperimento: la dimensione dello stride
//    non e' verificabile senza un vero test multi-scheda su browser reale, che
//    non possiamo eseguire. Un parametro non dimostrato dentro un meccanismo
//    di qualita' dei dati e' precisamente il pattern gia' rifiutato. Il costo
//    di sbagliarlo e' peggiore del difetto attuale: falsi buchi renderebbero
//    l'estimatore di perdita (eventLossRate, vedi repository.ts) non solo
//    silenzioso ma BUGIARDO, e farebbero diffidare anche di dati buoni.
//
// Perche' si puo' convivere col difetto per ora: il comportamento attuale
// fallisce in modo SICURO — nessun duplicato, nessun conteggio corrotto, solo
// perdita — e colpisce i bracci allo stesso modo (fenomeno lato client,
// indipendente dal braccio assegnato): il CONFRONTO fra bracci, l'unica cosa
// su cui si decide, non e' distorto. Solo il valore assoluto delle sessioni
// tracciate risulta leggermente sottostimato — stessa proprieta' gia' vera
// per il gate del consenso, vedi il commento qui sotto.
//
// Cosa si fa invece: rendere il fenomeno MISURABILE invece di correggerlo alla
// cieca. `insertEvents` (repository.ts, lato app) calcola gia' quante righe di
// un batch sono state davvero inserite (CTE + count(*) sull'INSERT con
// ON CONFLICT DO NOTHING) — la differenza col numero di eventi sottomessi e'
// esattamente il numero scartato per collisione. Va esposta come diagnostica
// sul dashboard, accanto a eventLossRate: solo con la frequenza reale sul
// traffico vero si potra' decidere se e come intervenire.

// Il consenso vale solo per la telemetria. L'assegnazione del braccio (snippet
// db-exp-assign) è funzionale e resta attiva a prescindere: senza, lo stesso
// visitatore vedrebbe prezzi diversi a ogni ricaricamento.
//
// Perché il gate non rende i dati inutilizzabili: il banner appare prima che
// il visitatore veda qualunque differenza fra i bracci (l'assegnazione è già
// fissata, ma il contenuto non dipende dalla scelta sul banner), quindi il
// tasso di consenso è identico su tutti i bracci per costruzione. I numeri
// assoluti di sessioni tracciate sono sottostimati (chi rifiuta non genera
// eventi), ma i RAPPORTI fra bracci — ciò che serve per decidere quale
// offerta vince — restano non distorti. È la proprietà che una misurazione
// via GA4 non avrebbe: lì la perdita di dati (blocco cookie, ad blocker) è
// correlata al comportamento osservato, non indipendente da esso.
let consented = null;   // null = non ancora deciso
let pending = [];       // eventi in attesa della decisione

// sessionStartSent/reboundTimer/emitSessionStart vivono qui, a livello di
// modulo, e non dentro `if (active) { ... }` dove stava l'"armamento" del
// tetto d'attesa (vedi piu' sotto): applyDecision() (I9, sotto) deve poterli
// leggere/scrivere per rendere durevole `db_session_start_sent` alla stessa
// transizione in cui rende durevole `db_sid` — e applyDecision() e' definita
// prima che `if (active)` inizi a eseguire. Inerti se `active` e' falso:
// nessuno le richiama, esattamente come push()/flush() sono definite sempre
// ma esercitate solo quando l'esperimento e' in running.
let sessionStartSent = false;
try {
  // Stessa sentinella di `seq` qui sopra: un session_start "gia' mandato" per
  // il test precedente non vale per quello nuovo, che invece deve riceverne
  // uno proprio — senza, la sessione non esisterebbe mai lato server.
  sessionStartSent = sessioneDiQuestoTest && sessionStorage.getItem('db_session_start_sent') === '1';
} catch (e) { sessionStartSent = false; }
// N1 (re-review finale): `sessionStartSent` deve registrare che session_start
// e' ENTRATO NELLA PIPELINE (pending o queue), non che ci abbiamo provato.
// `sessionStartAttempted`, invece, registra semplicemente che emitSessionStart()
// e' stato invocato almeno una volta su questa pagina, a prescindere
// dall'esito — serve solo ad applyDecision() per capire SE vale la pena
// ritentare quando il consenso passa a vero (vedi sotto), senza dover
// ripetere la logica di attesa rebound/resolved/tetto che l'ha gia' fatto
// scattare una volta.
let sessionStartAttempted = false;
let reboundTimer = null;
function emitSessionStart() {
  if (sessionStartSent) return;
  sessionStartAttempted = true;
  if (reboundTimer !== null) { clearTimeout(reboundTimer); reboundTimer = null; }
  // Il flag deve registrare che l'evento e' ENTRATO NELLA PIPELINE (pending o
  // queue), non che ci abbiamo provato: push() (sotto) scarta silenziosamente
  // il record quando consented === false. Impostare comunque il flag (e la
  // sua persistenza) marcherebbe come "spedito per sempre" un session_start
  // mai esistito — esattamente il difetto misurato: un visitatore il cui
  // consenso e' gia' 'no' quando il modulo viene valutato (Shopify persiste
  // la decisione fra le visite) che poi ACCETTA sulla stessa pagina non
  // vedrebbe mai partire il proprio session_start, perche' il flag,
  // impostato qui durante il tentativo scartato, bloccherebbe per sempre un
  // ritentativo. Se consented e' gia' false ORA, push() scartera' comunque:
  // non impostare ne' il flag ne' la persistenza — il ritentativo, se
  // arriva, e' compito di applyDecision() qui sotto.
  if (consented !== false) {
    sessionStartSent = true;
    // I9: db_session_start_sent diventa durevole solo se il consenso e' GIA'
    // vero in questo istante (visitatore che aveva gia' deciso su una pagina
    // precedente, o deciso presto su questa). Se il consenso e' ancora ignoto
    // (es. il tetto scade prima di qualunque decisione), non si scrive nulla
    // qui: tocca ad applyDecision() persisterlo quando/se il consenso passera'
    // davvero a "si'" — mai prima, per lo stesso motivo per cui `db_sid` non si
    // scrive piu' incondizionatamente in db-exp-assign.liquid.
    if (consented === true) {
      try { sessionStorage.setItem('db_session_start_sent', '1'); } catch (e) { /* modalità privata */ }
    }
  }
  push('session_start');
}

// analyticsProcessingAllowed() restituisce SEMPRE un booleano definito appena
// l'API e' caricata — false dove serve consenso, true altrove — anche se il
// visitatore non ha ancora toccato il banner. Usarlo per capire SE una decisione
// c'e' stata blocca lo stato in anticipo e rende il successivo
// visitorConsentCollected un no-op: dove il default e' true si raccoglierebbe
// contro un rifiuto esplicito, dove e' false si scarterebbe un consenso genuino.
// currentVisitorConsent().analytics distingue i tre casi: 'yes', 'no', '' (non deciso).
function allowed() {
  try {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;
    const consent = privacy.currentVisitorConsent();
    const analytics = consent && consent.analytics;
    if (analytics !== 'yes' && analytics !== 'no') return null; // '' = nessuna interazione ancora
    return typeof privacy.analyticsProcessingAllowed === 'function' &&
      privacy.analyticsProcessingAllowed() === true;
  } catch (e) {
    return null;
  }
}

// Unico punto che avanza e persiste il contatore: chiamato SOLO quando un
// evento e' davvero destinato a partire (vedi push()/decide() sotto) — mai
// per un evento che potrebbe restare in `pending` e non partire mai.
function nextSeq() {
  seq += 1;
  try { sessionStorage.setItem('db_seq', String(seq)); } catch (e) { /* modalità privata */ }
  return seq;
}

// applyDecision() e' la vera transizione di stato, sempre eseguibile: la
// guardia one-shot vive nei due chiamanti sotto, non qui, perche' non e' la
// stessa guardia per tutti — vedi decide() vs decideFromUserAction().
function applyDecision(value) {
  consented = value;
  if (value) {
    // I9: db_sid diventa durevole (scritto su sessionStorage) SOLO qui, alla
    // transizione verso un consenso concesso — mai prima. db-exp-assign.liquid
    // non lo scrive piu' incondizionatamente: se non trova un sid gia'
    // persistito, ne genera uno EFFIMERO valido solo per la pagina corrente
    // (window.DbExp.sid resta comunque sempre valorizzato — serve subito, in
    // modo sincrono e a prescindere dal consenso, all'attributo carrello
    // funzionale _exp_sid di bundle-selector.liquid all'add-to-cart). Scrivere
    // ORA e' idempotente: se era gia' durevole (pagina successiva sulla stessa
    // scheda, consenso gia' dato prima), riscrive lo stesso valore, innocuo.
    //
    // Simmetria richiesta: db_session_start_sent segue la stessa regola. Se
    // session_start e' gia' scattato su QUESTA pagina mentre il consenso era
    // ancora ignoto (es. il tetto d'attesa e' scaduto prima di una decisione),
    // emitSessionStart() non l'ha persistito — tocca a qui, ora che sappiamo
    // che il consenso e' vero. Se non e' ancora scattato, tocchera' a
    // emitSessionStart() stesso quando scattera', visto che a quel punto
    // troverà il consenso gia' vero.
    try {
      sessionStorage.setItem('db_sid', exp.sid);
      // Le sentinelle si scrivono INSIEME al sid, nella stessa transizione: se
      // una restasse indietro, la pagina successiva crederebbe di essere su un
      // test (o un braccio) diverso e rinnoverebbe la sessione ad ogni
      // caricamento. Il braccio persistito e' quello EFFETTIVO di questa
      // pagina (exp.arm), lo stesso con cui sidPerTest ha scelto il sid.
      sessionStorage.setItem('db_session_test', exp.testId);
      sessionStorage.setItem('db_session_arm', exp.arm);
    } catch (e) { /* modalità privata */ }
    // N1: se emitSessionStart() e' gia' stato tentato su questa pagina (il
    // tetto/rebound/resolved/unload l'ha gia' fatto scattare) ma NON e' mai
    // entrato nella pipeline — perche' consented era false in quel momento —
    // ritentalo ORA che il consenso e' vero. Guardia su `sessionStartAttempted`,
    // non solo su `!sessionStartSent`: se session_start non e' MAI stato
    // tentato (siamo ancora nella finestra d'attesa rebound/resolved/tetto,
    // il caso comune per un visitatore che accetta presto), NON bisogna
    // forzarlo qui — bypasserebbe l'attesa del riallineamento carrello e
    // reintrodurrebbe esattamente il bias braccio pre-rebound che quella
    // attesa esiste per evitare. emitSessionStart() e' comunque idempotente:
    // se sessionStartSent e' gia' vero (caso comune, promosso da `pending`
    // qui sotto) e' un no-op.
    if (sessionStartAttempted && !sessionStartSent) emitSessionStart();
    if (sessionStartSent) {
      try { sessionStorage.setItem('db_session_start_sent', '1'); } catch (e) { /* modalità privata */ }
    }
    // Solo ORA, che la decisione e' un accettato, i record di `pending`
    // diventano davvero destinati a partire: gli si assegna il seq qui,
    // nell'ordine in cui sono stati creati (`pending` e' gia' cronologico).
    // Prima di questo momento erano senza seq apposta — vedi push().
    for (const record of pending) record.seq = nextSeq();
    queue = pending.concat(queue);
    pending = [];
    flush(false);
  } else {
    // Rifiuto (o revoca): la coda si butta e non si accoda più nulla. Per una
    // revoca dopo un accettato, questo scarta solo cio' che non e' ancora
    // partito — coerente con la cookie policy ("la revoca non pregiudica la
    // liceita' del trattamento effettuato prima della revoca"): non possiamo
    // comunque richiamare indietro un evento gia' spedito da qui, ma tutto
    // cio' che era ancora in coda si ferma.
    //
    // N1: se session_start era finito in `pending` (consented era null
    // quando e' scattato) o in `queue` (consented era true e poi revocato
    // prima di un flush riuscito) e non e' MAI stato davvero consegnato, il
    // rifiuto/revoca lo scarta come tutto il resto — ma `sessionStartSent`
    // restava vero, quindi un'accettazione successiva (sopra) non l'avrebbe
    // piu' ritentato: lo stesso difetto misurato, raggiunto da un'altra
    // strada. Resettalo QUI, insieme allo scarto: `sessionStartAttempted`
    // resta vero (e' stato davvero tentato, rispettando l'attesa
    // rebound/resolved), cosi' un'accettazione successiva lo rimette in
    // gioco esattamente come il caso base sopra. Un evento GIA' spedito non
    // e' piu' ne' in `pending` ne' in `queue` (flush() li rimuove solo dopo
    // un invio davvero avviato), quindi questo controllo non lo tocca.
    if (
      pending.some((record) => record.ev === 'session_start') ||
      queue.some((record) => record.ev === 'session_start')
    ) {
      sessionStartSent = false;
    }
    pending = [];
    queue = [];
  }
}

// decide(): per le LETTURE di stato (il poll iniziale, il callback di
// loadFeatures) — entrambe scoprono un fatto gia' esistente, non un'azione
// nuova dell'utente, quindi restano one-shot fra loro: la prima che risolve
// vince, l'altra e' un no-op. Non deve pero' poter sovrascrivere una
// decisione gia' presa da un'azione esplicita (vedi sotto) — e infatti non
// puo': la stessa guardia lo impedisce a prescindere da chi ha deciso prima.
function decide(value) {
  if (consented !== null) return;
  applyDecision(value);
}

// decideFromUserAction(): per l'evento 'visitorConsentCollected' — l'utente
// ha appena agito sul banner, non e' una rilettura. NON e' one-shot: se
// l'utente accetta e poi riapre il banner per REVOCARE, questa chiamata deve
// applicarsi comunque, non restare bloccata dalla decisione precedente.
function decideFromUserAction(value) {
  applyDecision(value);
}

function context() {
  const params = new URLSearchParams(window.location.search);
  return {
    referrer: document.referrer || null,
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_content: params.get('utm_content'),
    utm_term: params.get('utm_term'),
    device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    viewport_w: window.innerWidth,
    viewport_h: window.innerHeight
  };
}

function flush(useBeacon) {
  if (consented !== true) return;
  if (queue.length === 0) return;
  const events = queue;
  // `queue` NON si svuota qui: si svuota solo dopo aver saputo che un invio e'
  // stato davvero accettato (vedi sotto). Finche' non lo sappiamo, `events` e
  // `queue` restano lo stesso array — se questa chiamata finisse per non
  // spedire nulla, il prossimo flush() ritroverebbe gli eventi, non li
  // perderebbe in silenzio.
  if (idleTimer !== null) { clearTimeout(idleTimer); idleTimer = null; }

  // N2 (re-review finale): la serializzazione (context()/JSON.stringify) vive
  // in un try/catch SEPARATO da quello di rete piu' sotto, perche' le due
  // eccezioni possibili qui vogliono l'OPPOSTO l'una dall'altra. Un payload
  // non serializzabile (riferimento circolare, BigInt, nodo DOM dentro un
  // oggetto piano) e' un difetto PERMANENTE di QUESTO batch: ririprovarlo a
  // ogni flush() successivo rilancerebbe SEMPRE la stessa eccezione — misurato:
  // dopo un payload circolare, zero invii, e un evento SANO push()ato subito
  // dopo non parte piu' nemmeno lui, perche' resta incolonnato dietro il
  // batch avvelenato che nessuno scarta mai. Il raggio del danno passava da
  // "un batch" a "tutta la telemetria della pagina, da qui in avanti", in
  // silenzio — l'opposto di quello che I8 doveva ottenere. Il rifiuto di
  // sendBeacon qui sotto e' invece transitorio (rete/limite di coda del
  // browser): li' la coda va CONSERVATA (I8), non scartata. Due cause, due
  // rimedi opposti: non possono condividere lo stesso ramo di errore.
  let payload;
  let contextIncluso = false;
  try {
    const body = { events };
    if (!contextSent && events.some((event) => event.ev === 'session_start')) {
      body.context = context();
      contextIncluso = true;
    }
    payload = JSON.stringify(body);
  } catch (e) {
    // Irrecuperabile: si scarta SOLO questo batch, non l'intera coda futura
    // (eventi non ancora generati non sono in `events`, quindi non ne sono
    // toccati). `contextSent` NON viene consumato qui (vedi sotto): un
    // context mai arrivato al server per colpa di QUESTO batch deve poter
    // essere ritentato dal prossimo batch sano che contiene un session_start.
    queue = [];
    return;
  }
  // contextSent si consuma SOLO ora che la serializzazione e' davvero
  // riuscita — prima veniva impostato PRIMA di JSON.stringify, quindi un
  // context incluso in un batch poi scartato per eccezione (sopra) risultava
  // "gia' inviato" pur non essendo mai partito.
  if (contextIncluso) contextSent = true;

  try {
    if (useBeacon && navigator.sendBeacon) {
      // Content-Type 'text/plain', non 'application/json': e' uno dei tre tipi
      // CORS "semplici", quindi questa richiesta non richiede un preflight
      // OPTIONS. Durante l'unload il preflight e' inaffidabile per costruzione
      // (la pagina puo' morire prima che completi), quindi l'unico modo per far
      // arrivare l'evento e' non averne bisogno. Il corpo resta JSON valido: il
      // server legge il body grezzo e fa JSON.parse senza mai controllare
      // l'header Content-Type in ingresso (route.ts).
      const accepted = navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'text/plain' }));
      if (accepted) { queue = []; return; }
      // sendBeacon ritorna false quando la coda interna del browser e' piena o
      // il payload supera il limite (64 KB in Chrome, raggiungibile con
      // MAX_BATCH = 50 eventi ricchi) — non un errore di rete: un rifiuto
      // SINCRONO e certo, noto subito, a differenza di fetch qui sotto (il cui
      // esito arriva async e resta comunque ignoto). Prima di questa
      // correzione il batch, in quel caso, spariva: la coda era gia' stata
      // svuotata sopra e nessuno lo ritentava. fetch(keepalive:true) e'
      // pensato per lo stesso caso d'uso di sendBeacon — sopravvivere
      // all'unload — quindi e' l'unico ripiego sensato qui, nello stesso giro,
      // non al prossimo flush (per allora la pagina potrebbe gia' essere
      // scaricata).
    }
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
      mode: 'cors'
    }).catch(() => {});
    // Svuota solo ORA che l'invio (beacon accettato sopra con return, o questo
    // fetch) e' stato davvero avviato — non prima. Un'eccezione qui (rete,
    // non serializzazione — quella e' gia' stata isolata sopra) lascia la
    // coda intatta: puo' essere transitoria, a differenza di un payload
    // permanentemente non serializzabile.
    queue = [];
  } catch (e) { /* la telemetria non deve mai rompere la pagina */ }
}

function push(ev, payload, sectionId) {
  if (!active || typeof ev !== 'string') return;
  if (consented === false) return;
  // Cintura in più oltre al try di flush(): sostituisce con {} solo null,
  // undefined, primitivi e array — cioè un cambio di comportamento reale per
  // chi oggi chiamasse push con uno scalare o un array come payload (nessun
  // chiamante attuale lo fa). NON filtra oggetti esotici (nodo DOM, oggetto
  // con riferimento circolare al suo interno): quelli passano intatti, e la
  // difesa contro di loro resta il try in flush(), non questa guardia.
  const safePayload =
    payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
  const record = {
    uid: exp.uid,
    sid: exp.sid,
    // seq assegnato PIÙ SOTTO, non qui: se il consenso non è ancora deciso,
    // questo record finisce in `pending` e potrebbe non partire mai (il
    // visitatore lascia la pagina senza rispondere al banner). Consumare e
    // persistere un numero di sequenza ORA, prima di sapere se l'evento sarà
    // davvero spedito, brucia un numero che il server legge come "generato
    // e mai arrivato" — un buco fantasma — anche quando non è mai stato
    // generato per davvero. Vedi nextSeq() e decide().
    seq: null,
    test: exp.testId,
    arm: exp.arm,
    ev,
    ts: new Date().toISOString(),
    path: window.location.pathname,
    section_id: sectionId || '',
    payload: safePayload
  };
  // Prima della decisione l'evento non va perso: si accoda in `pending` e
  // parte solo se e quando l'utente accetta (vedi decide()).
  if (consented === null) { pending.push(record); return; }
  record.seq = nextSeq();
  queue.push(record);

  if (queue.length >= MAX_BATCH) { flush(false); return; }
  if (idleTimer !== null) clearTimeout(idleTimer);
  idleTimer = setTimeout(() => flush(false), IDLE_MS);
}

window.DbTrack = { push };

if (active) {
  const initial = allowed();
  if (initial !== null) decide(initial);

  // Questo e' l'evento che Shopify dispaccia quando l'utente AGISCE sul
  // banner — accetta, rifiuta, o riapre le preferenze per REVOCARE una
  // decisione gia' presa. decide() (one-shot) lascerebbe una revoca
  // successiva all'accettazione come un no-op: decideFromUserAction() si
  // applica sempre, perche' qui non stiamo rileggendo uno stato, e' l'utente
  // che ha appena deciso.
  document.addEventListener('visitorConsentCollected', (event) => {
    decideFromUserAction(event?.detail?.analyticsAllowed === true);
  });

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    // Se lanciasse senza questo try, push('session_start') e i listener
    // visibilitychange/pagehide qui sotto non verrebbero mai registrati: la
    // telemetria morirebbe in silenzio per l'intera pagina, rete di sicurezza
    // sull'unload inclusa.
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => { const value = allowed(); if (value !== null) decide(value); }
      );
    } catch (e) { /* la telemetria non deve mai rompere la pagina */ }
  }

  // session_start cattura `exp.arm` PER VALORE nel momento in cui parte (`push()`
  // legge `exp.arm` una volta sola dentro `record`, sopra): se partisse subito,
  // prima che db-exp-assign.liquid corregga `window.DbExp.arm` col
  // riallineamento carrello (fetch asincrono verso /cart.js), la sessione
  // resterebbe registrata sul braccio pre-rebound mentre tutti gli eventi
  // successivi e l'ordine finiscono sul braccio corretto — un bias asimmetrico
  // (il rebound corregge una sola direzione), non rumore neutro, su un
  // esperimento la cui metrica principale e' ordini/sessioni.
  //
  // Si aspetta quindi l'esito della verifica, entro un tetto, prima di mandare
  // l'evento. Due segnali da db-exp-assign.liquid, non uno: 'db-exp:rebound'
  // scatta SOLO se una correzione avviene davvero; 'db-exp:resolved' scatta
  // SEMPRE che la verifica concluda (successo con o senza correzione,
  // fallimento del fetch) — e' quindi il segnale che chiude il caso comune
  // (nessuna correzione necessaria) senza aspettare il tetto pieno.
  // 'db-exp:rebound' resta comunque ascoltato: se in futuro 'resolved'
  // arrivasse un istante DOPO 'rebound' invece che nello stesso giro (oggi non
  // succede, ma non e' un'invariante di questo file), session_start non deve
  // comunque perdere la correzione. Mai due volte (`sessionStartSent` e'
  // l'unico varco, condiviso da tutte e quattro le vie d'uscita), mai a tempo
  // indefinito (il timeout e i listener di unload restano indipendenti da
  // entrambi i segnali).
  // session_start e' per SESSIONE (sid), non per pagina caricata — vedi
  // `sessionStartSent`/`reboundTimer`/`emitSessionStart` sopra, a livello di
  // modulo (I9 li ha spostati li' perche' applyDecision() deve poterli
  // leggere/scrivere; il comportamento verso il chiamante qui e' identico).
  //
  // CAMBIO DI INVARIANTE (I9): `sid` — e con esso `sessionStartSent` — non e'
  // piu' stabile fra pagine in assoluto, e' stabile SOLO DAL CONSENSO IN
  // POI. Prima di I9, db-exp-assign.liquid scriveva `db_sid` su sessionStorage
  // incondizionatamente, ad ogni prima pagina della scheda; ora, se non trova
  // un sid gia' reso durevole da applyDecision() (vedi sopra), ne genera uno
  // EFFIMERO, valido solo per la pagina corrente. Conseguenza onesta, non
  // nascosta: un visitatore che ricarica piu' volte senza mai decidere sul
  // banner ha un sid (e quindi anche `sessionStartSent`) diverso ad ogni
  // pagina — non si perde pero' nulla che oggi non fosse gia' perso, perche'
  // `pending` non sopravvive comunque al cambio pagina finche' il consenso
  // resta indeciso. Un visitatore che compra senza aver mai deciso porta un
  // `_exp_sid` che non corrisponde a nessuna riga in `experiment_sessions` —
  // non e' un buco: e' esattamente cio' che gia' prevede `ordersWithoutSession`
  // lato app, la sessione e' fuori dal denominatore quanto l'ordine e' fuori
  // dal numeratore, le due cose combaciano.
  //
  // Perche' era necessario, non solo desiderabile: `db_sid`/`db_seq` sono
  // sessionStorage, non cookie HTTP, ma la cookie policy pubblica dichiara
  // che si attivano "esclusivamente previo consenso espresso" — scrivere un
  // identificatore sul dispositivo prima del consenso e' comunque
  // ARCHIVIAZIONE SU DISPOSITIVO, e il fatto che non venga trasmesso non la
  // rende automaticamente lecita. Rendere vero il codice, non allineare il
  // testo al ribasso.
  //
  // Se una pagina precedente della stessa scheda ha gia' mandato session_start,
  // non ha senso armare il tetto d'attesa ne' ascoltare rebound/resolved qui:
  // emitSessionStart() sarebbe comunque un no-op. I listener di unload restano
  // SEMPRE registrati (vedi sotto): flush(true) deve girare a prescindere,
  // non solo quando session_start e' ancora in sospeso.
  //
  // Ma "non ancora mandato" non e' la stessa domanda di "la verifica carrello
  // e' ancora in sospeso": questo script e' un asset deferred, valutato DOPO
  // l'inline di db-exp-assign.liquid, e il fetch a /cart.js che quello innesca
  // puo' benissimo aver gia' risolto (rete veloce/cache) prima che questo file
  // arrivi a eseguire. In quel caso 'db-exp:rebound'/'db-exp:resolved' sono
  // gia' stati dispacciati e persi — nessun listener era ancora registrato —
  // e armare comunque il tetto pieno significa aspettare REBOUND_WAIT_MS senza
  // alcun motivo: la risposta (`exp.resolved`) e' gia' nota ORA. `!exp` copre
  // lo stesso ramo per prudenza, anche se non dovrebbe mai accadere qui dentro
  // `if (active)`.
  if (!sessionStartSent) {
    if (!exp || exp.resolved !== false) {
      emitSessionStart();
    } else {
      reboundTimer = setTimeout(emitSessionStart, REBOUND_WAIT_MS);
      document.addEventListener('db-exp:rebound', emitSessionStart, { once: true });
      document.addEventListener('db-exp:resolved', emitSessionStart, { once: true });
    }
  }

  // Il braccio è una proprietà della SESSIONE, non dell'istante in cui un
  // evento accade: push() (sopra) scrive `record.arm = exp.arm` per valore al
  // momento della chiamata, quindi ogni evento generato PRIMA di un rebound
  // porta lo snapshot vecchio — anche se non è ancora partito verso il
  // server. `session_start` è già protetto (aspetta la risoluzione sopra
  // prima di generarsi); questo copre gli eventi ambientali che nel frattempo
  // possono già essere stati generati (scroll, offer_view, un tier_select
  // precoce...): non aspettano nulla per costruzione (vedi push()), quindi
  // possono benissimo essere finiti in coda con l'arm sbagliato.
  //
  // Si corregge sul POSTO, non si duplica: `pending` (in attesa del consenso)
  // e `queue` (già pronta per il prossimo flush) sono mutabili finché non
  // sono stati inviati — non c'è nulla di irreversibile da disfare. Il
  // `seq` di ciascun record resta quello assegnato al push originale: si
  // riscrive solo `arm`, mai altro, e non si genera nessun record nuovo, quindi
  // nessun secondo invio e nessun buco di seq.
  //
  // Ascolta 'db-exp:rebound' e non 'db-exp:resolved': è il momento esatto in
  // cui `exp.arm` cambia (db-exp-assign.liquid lo scrive PRIMA di dispacciare
  // l'evento), non solo il momento in cui la verifica è conclusa — i due
  // eventi oggi coincidono nello stesso giro di promise, ma la correzione
  // dell'arm è concettualmente legata al primo, non al secondo.
  //
  // Limite reale, non nascosto: un evento già SPEDITO (idle-timer, MAX_BATCH,
  // o il flush di unload) prima che il rebound arrivasse resta sul braccio
  // pre-rebound per sempre — non più raggiungibile da qui, e ritentarne
  // l'invio duplicherebbe quel seq. Non tutti gli eventi di una sessione con
  // rebound sono quindi garantiti coerenti fra loro: è un limite del sistema,
  // non un'incoerenza di questo listener.
  document.addEventListener('db-exp:rebound', () => {
    for (const record of pending) record.arm = exp.arm;
    for (const record of queue) record.arm = exp.arm;
  });

  // ---------- checkout_click ----------
  // L'ULTIMO passo del funnel misurabile da qui. Oltre questo bottone si va sul
  // checkout di Shopify, che sta su un dominio suo dove questo script non gira e
  // non puo' essere iniettato: "quante sessioni hanno RAGGIUNTO il checkout" non
  // e' ottenibile, e questo evento non pretende di dirlo. Dice "ha premuto per
  // pagare", che e' un fatto diverso e piu' debole — chi legge la metrica deve
  // vedere quel nome, non "checkout rate" tout court.
  //
  // Listener DELEGATO su document, non uno script dentro cart-summary.liquid:
  // quel file e' il carrello di tutto il negozio ed e' reso piu' volte per
  // pagina (cassetto + pagina carrello), quindi un listener inline si
  // attaccherebbe due volte e sdoppierebbe l'evento. Qui si attacca una volta
  // sola perche' questo modulo e' valutato una volta sola.
  //
  // In cattura (true) e non in bolla: il bottone e' `type="submit"` di
  // `form="cart-form"`, e un submit che porta via la pagina puo' impedire alla
  // fase di bolla di completarsi. push() accoda soltanto; a spedire davvero
  // saranno i listener di unload qui sotto, con sendBeacon.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    // #checkout e' l'id del bottone principale (snippets/cart-summary.liquid);
    // [name="checkout"] copre le altre forme di carrello del tema. I bottoni di
    // pagamento accelerato (Shop Pay, PayPal) NON passano di qui: vivono in un
    // iframe di Shopify, e restano fuori dalla misura. Limite dichiarato.
    if (!target.closest('#checkout, [name="checkout"]')) return;
    push('checkout_click', {}, '');
  }, true);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      // Se l'attesa e' ancora in corso, session_start deve uscire ORA, nello
      // stesso beacon finale: una sessione mai registrata e' peggio di una
      // registrata sul braccio pre-rebound.
      emitSessionStart();
      flush(true);
    }
  });
  window.addEventListener('pagehide', () => {
    emitSessionStart();
    flush(true);
  });
}
